import creator from '@utils/creator.js';

import SliderProductGallery from '@components/SliderProductGallery';
import ProductStickyBar from '@components/ProductStickyBar';
import AnchorEnvironment from '@components/AnchorEnvironment.js';
import ProductReviewsIO from '@components/ProductReviewsIO.js';
import SingleVariantPriceHandler from '@components/SingleVariantPriceHandler.js';

function ClrzAppInit() {
	ClrzApp.SliderProductGallery = creator(
		'.js-slider-product-gallery',
		SliderProductGallery,
	);
	ClrzApp.ProductStickyBar = creator('.js-product-sticky', ProductStickyBar);
	ClrzApp.AnchorEnvironment = creator(
		'.js-anchor-environment',
		AnchorEnvironment,
	);
	customElements.define('product-reviews-io', ProductReviewsIO);

	// Initialiser la gestion des prix pour les produits avec un seul variant
	new SingleVariantPriceHandler();
}

ClrzAppInit();
